<template>
    <div id="image-filter">

        <div class="slider-for">
            
            <div class="slick-active slick-current">

                <div v-if="infoWinOpen" class="image-popup" v-on:click="clickOutside($event)" >
                    <div>
                        <opinion @close-popup="infoWinOpen=false" :currentOpinion="currentOpinion" :slide="slide"/>
                    </div>
                </div>

                <div ref="imagecomponent" class="wrapper" v-on:mousewheel="wheel_handler">
                    <div class="image-wrapper"
                    >
                        <img
                            v-on:mouseup="mouseup_handler($event, slide)"
                            v-on:mousedown="mousedown_handler($event,slide)"
                            v-on:pointerup="pointerup_handler"
                            v-on:pointerdown="pointerdown_handler"
                            v-on:pointermove="pointermove_handler"
                            v-on:pointercancel="pointerup_handler"
                            v-on:pointerout="pointerup_handler"
                            v-on:pointerleave="pointerup_handler"
                            v-touch:start="touchStart"
                            v-touch:end="touchEnd(slide)"
                            class="image-type-slide" :src="'/images/projects/' + slide.assets" />
                        <img
                            :src="getPinImage(m)"
                            class="pin"
                            :class="hidePinClass(m)"
                            :v-if="collectedAnswers"
                            :style="pinStyle(m)"
                            v-for="(m, markerindex) in collectedAnswers"
                            :key="markerindex"
                            v-on:click="toggleOpinion(m)"
                        >
                        <!-- https://github.com/jerrybendy/vue-touch-events -->
                    </div>
                </div>

            </div>
        </div>

        <div id="zoom-image" >
            <button v-on:click="zoomInHandler(true)" v-touch:tap="zoomInHandler(false)">
                <i class="fas fa-plus"></i>
            </button>
            <button v-on:click="zoomOutHandler(true)" v-touch:tap="zoomOutHandler(false)">
                <i class="fas fa-minus"></i>
            </button>
        </div>

    </div>
</template>

<script>

import { clickOutside } from '../../../tool/functions'

import { repositionImage, zoomIn, zoomOut } from '../../../tool/image-functions'

import Opinion from './Opinion'

export default {

    data() {
        return {
            collectedAnswers : [],
            imageMarkerPosX: null,
            imageMarkerPosY: null,
            threshold : 5,
            cursorPosition : {
                clientX: 0,
                clientY: 0
            },
            eCache : [],
            prevDiff : -1,
            directionY : 0,
            directionX : 0,

            imageReady: false,
            infoWindowPos : { lat : null, lng: null },
            infoWinOpen : false,
            currentOpinion : [],

            clickOutside
        }
    },

    props: {
        filters : Object,
        slide : Object
    },

    watch: {
        filters(newItems, oldItems) {
            if(oldItems !== newItems) {
                this.getData();
            }
        },
    },

    mounted() {

        $('.wrapper').kinetic({
            cursor: 'auto',
            filterTarget: function (target, e) {
                if (!/down|start/.test(e.type)) {
                    return !(/div/i.test(target.tagName));
                }
            }
        });

        this.getData()
    },

    components: {
        Opinion
    },

    methods : {

        getData: function() {

            axios.post(`/api/get-filtered-map`, { filters: this.filters })
            .then((res) => {
                this.collectedAnswers = res.data
                repositionImage()
            })
            .catch((err) => {
                console.error(err);
            });
        },

        getPinImage(marker) {
            return marker.value_type === 'good' ? '/images/pin_bra.png' : '/images/pin_forbattra.png';
        },


        hidePinClass: function(m) {

            if(this.multi && this.multi != 'null') {
                let multi = JSON.parse(m.multi);

                if(Array.isArray(multi)) {
                    let first = multi.shift();
                    if(first !== m.id) {
                        return 'hide'
                    }
                }
            }

            return ''
        },

        zoomInHandler: function(type) {
            zoomIn(type);
        },

        zoomOutHandler: function(type) {
            zoomOut(type);
        },

        toggleOpinion: function(marker) {

            this.infoWindowPos = {
                lat : parseFloat(marker.lat),
                lng : parseFloat(marker.lng)
            }

            this.infoWinOpen = true;
            this.currentOpinion = this.collectedAnswers && this.collectedAnswers.length && marker ? this.collectedAnswers.filter( el => el.lat == marker.lat && el.lng == marker.lng) : [marker];
        },

        runKinetic: function() {
            $('.wrapper').kinetic('attach');
        },

        removeKinetic: function() {
            $('.wrapper').kinetic('detach');
        },

        pickup: function(m, event, isDesktop) {

            let pinTop = $(event.target).offset().top;
            let pinLeft = $(event.target).offset().left;
            let clientY = event.clientY;
            let clientX = event.clientX;
            let heightPin = $(event.target).height()
            let widthtPin = $(event.target).width()

            m.diffY = isDesktop ? Math.abs(pinTop - clientY ) - (heightPin / 2) : 0;
            m.diffX = isDesktop ? Math.abs(pinLeft - clientX ) - (widthtPin / 2) : 0;
        },

        toggleEventTouchOnPin: function(obj){
            return (e) => {
                if(e.type === 'touchend'){
                    toggleOpinionForm(obj.m);
                }
            }
        },

        press(clientX, clientY) {
            this.cursorPosition.clientX = clientX;
            this.cursorPosition.clientY = clientY;
        },

        release(clientX, clientY, e, slide) {

            let image = $(e.target);

            if ((this.cursorPosition.clientX > clientX - this.threshold && this.cursorPosition.clientX < clientX + this.threshold) && (this.cursorPosition.clientY > clientY - this.threshold && this.cursorPosition.clientY < clientY + this.threshold)) {
                let offset = $('.slick-active .image-wrapper').offset();
                // Calculate marker position
                let posX = (($('.slick-active .image-type-slide').scrollLeft() + clientX - offset.left) / image.width()) * 100;
                // 19 is half of 38 which is the height of the pin, its not rendered yet, so need to put it in here for now
                let posY = (($('.slick-active .image-type-slide').scrollTop() + clientY - offset.top - 19) / image.height()) * 100;

                if(this.addopinion === true){
                    this.addMarker(parseFloat(slide.id), posX, posY)
                }


            }
            else {
                e.preventDefault();
            }
        },

        touchStart(e) {

            if(e.type === 'touchstart'){
                if (e.changedTouches.length === 1) {
                    this.press(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
                }
            }
        },

        touchEnd(slide) {
            return (e) => {
                if(e.type === 'touchend'){
                    if (e.changedTouches.length === 1) {
                        this.release(e.changedTouches[0].clientX, e.changedTouches[0].clientY, e, slide);
                    }
                }
            }
        },

        wheel_handler(e) {
            if (e.wheelDelta >= 0) {
                zoomIn(true);
            }
            else {
                zoomOut(true);
            }
        },

        pointerdown_handler(e) {
            // The pointerdown event signals the start of a touch interaction
            this.eCache.push(e);
        },

        pointermove_handler(e) {

            // Find this event in the cache and update its record with this event
            for (var i = 0; i < this.eCache.length; i++) {
                if (e.pointerId == this.eCache[i].pointerId) {

                    this.eCache[i] = e;
                    break;
                }
            }

            // If two pointers are down, check for pinch gestures
            if (this.eCache.length == 2) {
                // Calculate the distance between the two pointers
                var curDiff = Math.abs(this.eCache[0].clientX - this.eCache[1].clientX);

                if (this.prevDiff > 0) {
                    if (curDiff > this.prevDiff) {
                        // The distance between the two pointers has increased
                        zoomIn(false);
                    }
                    if (curDiff < this.prevDiff) {
                        // The distance between the two pointers has decreased
                        zoomOut(false);
                    }
                }

                // Cache the distance for the next move event
                this.prevDiff = curDiff;
            }
        },

        pointerup_handler(e) {
            // Remove this pointer from the cache and reset the target's
            // background and border
            this.remove_event(e);

            $('.slick-active body').css('background-color', 'white');

            // If the number of pointers down is less than two then reset diff tracker
            if (this.eCache.length < 2) {
                this.prevDiff = -1;
            }
        },

        mousedown_handler(e) {
            this.press(e.clientX, e.clientY);
        },

        mouseup_handler(e, slide) {
            this.release(e.clientX, e.clientY, e, slide);
        },

        remove_event(e) {
            // Remove this event from the target's cache
            for (var i = 0; i < this.eCache.length; i++) {
                if (this.eCache[i].pointerId == e.pointerId) {
                    this.eCache.splice(i, 1);
                    break;
                }
            }
        },

        pinStyle (marker) {
            return `position: absolute; left: ${marker.lng}%; top: ${marker.lat}%; transform: translate(-50%,-50%); width: 30px; height: 38px; visibility: initial;`
        },



    }
};

</script>

